import React, { useEffect, useMemo, useState } from "react";
import DataGrid from "../Components/DataGrid";
import Button from "../Components/Button";
import RichTextBox from "../Components/RichTextBox";
import DateInput from "../Components/DateInput";
import DarkModal from "../Components/DarkModal";  
import EuroInput from "../Components/EuroInput";
import SearchableSelect from "../Components/SearchableSelect";  
import { useDataset } from "../Hooks/useDataset";
import { formatDateIT } from "../Hooks/dateUtils";

export default function SegnalazioniPage() {
const [selectedRow, setSelectedRow] = useState(null);
const [isOpen, setIsOpen] = useState(false);
const [form, setForm] = useState({ IMPORTO_PAGATO: "" });

const [savingImporto, setSavingImporto] = useState(false);
const [saveImportoErr, setSaveImportoErr] = useState("");
const [saveImportoOk, setSaveImportoOk] = useState("");
const [filtroStato, setFiltroStato] = useState("Aperte");

function openDettaglio(row) {
  setSelectedRow(row);
  setIsOpen(true);
}

function closeDettaglio() {
  setIsOpen(false);
  setSelectedRow(null);
}

  const { rows, loading, error, reload } = useDataset({
    url: "https://api.lapegna.xyz/registro_segnalazioni"
  });

  const rowsFiltered = useMemo(() => {
    if (!rows) return [];

    switch (filtroStato) {
      case "Aperte":
        return rows.filter(r => r.Stato === "Aperta");

      case "Chiuse":
        return rows.filter(r => r.Stato === "Chiusa");

      default:
        return rows;
    }
  }, [rows, filtroStato]);



  const toISODate = (v) => {
  if (!v) return "";

  // già ISO yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;

  // datetime ISO: yyyy-mm-ddTHH:mm...
  if (/^\d{4}-\d{2}-\d{2}T/.test(v)) return v.slice(0, 10);

  // formato italiano dd/mm/yyyy
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
    const [dd, mm, yyyy] = v.split("/");
    return `${yyyy}-${mm}-${dd}`;
  }

  // prova fallback (se arriva Date o stringa parseabile)
  const d = v instanceof Date ? v : new Date(v);
  if (Number.isNaN(d.getTime())) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};


  {/* Carica fornitori per la combobox */}
    const [fornitori, setFornitori] = useState([]);
    const [loadingFornitori, setLoadingFornitori] = useState(false);
    useEffect(() => {
      const loadFornitori = async () => {
        try {
          setLoadingFornitori(true);
          const token = localStorage.getItem("token");
            const res = await fetch("https://api.lapegna.xyz/anafornitori", {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });

            if (!res.ok) throw new Error("Errore nel caricamento fornitori");
            const data = await res.json();
            setFornitori(data.fornitori);
          } catch (err) {
            console.error(err);
            alert("Errore nel caricamento fornitori");
          } finally {
            setLoadingFornitori(false);
          }
        };
        loadFornitori();
      }, []);


  {/* Formatto le colonne importo e visualizzazione */}
  const handleChange = (eOrValue) => {
  // Caso A: onChange(event)
  if (eOrValue && eOrValue.target) {
    const { name, value } = eOrValue.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    return;
  }

  // Caso B: onChange(value) — NON so il name, quindi lo gestiamo “per campo”
  // In questo file lo usi solo per DateInput / EuroInput / ecc? Qui sotto ti faccio vedere come usarlo sul DateInput.
};

  function openDettaglio(row) {
  setSelectedRow(row);
  setForm({
    ...row,
  });
  setIsOpen(true);
}


function openDettaglio(row) {
  setSelectedRow(row);
  setForm({
    ...row,
    DATA_AFFIDAMENTO: toISODate(row.DATA_AFFIDAMENTO),
    DATA_PAGAMENTO: toISODate(row.DATA_PAGAMENTO),
    DATA_COMPLETAMENTO: toISODate(row.DATA_COMPLETAMENTO),
  });
  setIsOpen(true);
}


  {/* Formatto le colonne come testo e visualizzazione */}
  const columns = useMemo(() => [
   {
      key: "ID",
      label: "ID",
    },
    {
      key: "__azioni__",
      label: "Azioni",
      sortable: false,
      exportable: false,
      render: (value, row) => (<Button variant="secondary" onClick={() => openDettaglio(row)}> Apri   </Button>),
    },
    {
      key: "Stato",
      label: "Stato",
    },
    {
      key: "DATA_SEGNALAZIONE",
      label: "Data segnalazione",
      render: formatDateIT,
      csvValue: formatDateIT
    },
    {
      key: "CONDOMINIO",
      label: "Condominio",
    },
    {
      key: "CONDOMINO",
      label: "Condomino",
    },
    {
      key: "TITOLO",
      label: "Titolo",
    },
    {
      key: "DENOMINAZIONE",
      label: "Fornitore",
    },
    {
      key: "DATA_AFFIDAMENTO",
      label: "Data affidamento",
      render: formatDateIT,
      csvValue: formatDateIT
    }
  ], []);

  if (loading) return <div>Caricamento...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  {/* Nasconde le colonne prima di visualizzarle */} 
  const columnsFiltered = columns.filter(
    c => !["ID", "FK_FORNITORE","DESCRIZIONE", "DATA_CREAZIONE", "UTENTE_CREAZIONE", "DATA_MODIFICA","UTENTE_MODIFICA"].includes(c.key)
  );


  {/*Preparo le variabili per salvare l'aggiornamento della MODALE */}
      const AGGIORNA_IMPORTO_URL_BASE = "https://api.lapegna.xyz/segnalazione_update";
     
      const getTokenOrThrow = () => {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token mancante in localStorage (chiave: 'token').");
        return token;
      };

      async function salvaImportoAggiornato() {
        try {
          setSavingImporto(true);
          setSaveImportoErr("");
          setSaveImportoOk("");

          // ✅ ID dinamico (consigliato)
          const id = form.ID || selectedRow?.ID || 1;

          const token = getTokenOrThrow();

          const payload = {
            IMPORTO_PAGATO: form.IMPORTO_PAGATO === "" ? null : Number(form.IMPORTO_PAGATO),
            DATA_PAGAMENTO: form.DATA_PAGAMENTO || null,
            DATA_COMPLETAMENTO: form.DATA_COMPLETAMENTO || null,
            DESCRIZIONE: form.DESCRIZIONE || null,
            FK_FORNITORE: form.FK_FORNITORE || null,
            DATA_AFFIDAMENTO: form.DATA_AFFIDAMENTO || null,
          };

          const res = await fetch(`${AGGIORNA_IMPORTO_URL_BASE}/${id}`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          if (!res.ok) {
            const txt = await res.text();
            throw new Error(txt || `Errore HTTP ${res.status}`);
          }

          setSaveImportoOk("Scheda aggiornata!");
          await reload(); // ricarica la griglia
        } catch (e) {
          console.error(e);
          setSaveImportoErr(e.message || "Errore aggiornamento");
        } finally {
          setSavingImporto(false);
        }
      }
  

  return (
    <div>
     
      <div style={{
        display: "flex",
        gap: 12,
        alignItems: "center",
        marginBottom: 10
      }}>

        <Button onClick={() => reload()}>Ricarica</Button>

        <div>
          <label style={{ fontSize: 13, opacity: 0.8 }}>Stato:</label>
          <select
            value={filtroStato}
            onChange={(e) => setFiltroStato(e.target.value)}
            style={{
              marginLeft: 8,
              padding: "6px 10px",
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.15)",
              background: "linear-gradient(180deg, #1f2937, #111827)",
              color: "white"
            }}
          >
            <option value="Aperte">Aperte</option>
            <option value="Chiuse">Chiuse</option>
            <option value="Tutte">Tutte</option>
          </select>

          </div>
      </div>


      <DataGrid
        title="Segnalazioni"
        rows={rowsFiltered}
        columns={columnsFiltered}
        initialHidden={[
          "CONDOMINO",
        ]}
      />


      <div style={{ padding: "12px 0 0 0" }}>
        <label style={{ fontSize: 13, opacity: 0.8 }}>Test</label>  
      </div>


      <DarkModal
        open={isOpen}
        title={selectedRow ? `Dettaglio segnalazione:  ${selectedRow.TITOLO}` : "Dettaglio segnalazione"}
        onClose={closeDettaglio}
      >
        {!selectedRow ? (
        <div style={{ opacity: 0.85 }}>Nessun dettaglio selezionato.</div>
        ) : (
        <div style={{ display: "grid", gap: 10 }}>
          <div style={{ whiteSpace: "pre-wrap" }}>
            {`Condominio: ${selectedRow.CONDOMINIO}`}
            <br /> <br />
            {`Data segnalazione: ${formatDateIT(selectedRow.DATA_SEGNALAZIONE)}`}
            <br /> <br />
            Condomino: {selectedRow.CONDOMINO} 
          </div>
                        
         
          <div style={{
            display: "flex",
            alignItems: "flex-end",
            gap: "32px"
          }}>
            <span style={{ color: "white" }}>Fornitore: </span>
            
            <div style={{ width: "220px" }}>
              <SearchableSelect
                name="FK_FORNITORE"
                value={form.FK_FORNITORE ?? ""}
                onChange={handleChange}
                disabled={loadingFornitori}
                placeholder={loadingFornitori ? "Caricamento..." : "-- Seleziona un fornitore --"}
                options={fornitori.map((f) => ({
                  value: f.ID,
                  label: f.DENOMINAZIONE,
                }))}
              />
            </div>

            <span style={{ color: "white" }}>Data affidamento:</span>
              <DateInput
                label=""
                name="DATA_AFFIDAMENTO"
                value={form.DATA_AFFIDAMENTO ?? ""}
                onChange={handleChange}
                width="180px"
              />

          </div>

          <RichTextBox
            label="Descrizione della segnalazione"
            name="DESCRIZIONE"
            value={form.DESCRIZIONE}
            onChange={handleChange}
            minHeight={70}
            maxHeight={420}
          />
          
          <br />  
         <DateInput
            label="Data completamento"
            name="DATA_COMPLETAMENTO"
            value={toISODate(form.DATA_COMPLETAMENTO)}
            onChange={(x) => {
              if (x?.target) return handleChange(x);
              setForm((prev) => ({ ...prev, DATA_COMPLETAMENTO: x }));
            }}
            width="180px"
          />

          <div style={{ whiteSpace: "pre-wrap" }}> 
          
          <DateInput
              label="Data pagamento"
              name="DATA_PAGAMENTO"
              value={toISODate(form.DATA_PAGAMENTO)}
              onChange={(x) => {
                if (x?.target) return handleChange(x);
                setForm((prev) => ({ ...prev, DATA_PAGAMENTO: x }));
              }}
              width="180px"
            />
          
            <EuroInput
              label="Importo"
              name="IMPORTO_PAGATO"
              value={form.IMPORTO_PAGATO}
              onChange={handleChange}
            />
          </div>
          
          <Button onClick={salvaImportoAggiornato} disabled={savingImporto}>
            {savingImporto ? "Salvataggio..." : "Salva modifiche"}
          </Button>

          {saveImportoOk && <div style={{ color: "#34d399", marginTop: 9 }}>{saveImportoOk}</div>}
          {saveImportoErr && <div style={{ color: "#fb7185", marginTop: 9 }}>{saveImportoErr}</div>}

         </div>
        )}
      </DarkModal>
    </div>
  );
}
